import React from 'react';
import { Col, Layout, Row, Typography } from 'antd';
import GreetingsTop from '../../../../components/Admin/GreetingsTop/GreetingsTop';
import ClientsTable from '../../../../components/Admin/Administration/ClientsTable';
import './Clients.scss';
import BackButton from '../../../../components/General/BackButton/BackButton';

export default function Clients() {
  return (
    <Layout>
      <GreetingsTop />

      <HeaderTop />

      <div className="clients__container">
        <ClientsTable />
      </div>
    </Layout>
  );
}

function HeaderTop() {
  const { Title } = Typography;

  return (
    <div className="clients__container">
      <Row xs={23} className="header-top" justify="space-between">
        <Col
          xs={19}
          className="header-top__left"
          style={{ position: 'relative' }}
        >
          <Title
            level={3}
            style={{
              // position: 'absolute',
              top: 0,
              bottom: 0,
              height: '78%',
              margin: 'auto',
            }}
          >
            Clientes
          </Title>
        </Col>
        <Col xs={5}>
          <Row
            style={{
              marginBottom: 30,
              justifyContent: 'right',
            }}
          >
            <BackButton routeName={'/administracion'}></BackButton>
          </Row>
        </Col>
      </Row>
    </div>
  );
}
